import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import MongolHistory from '@/components/MongolHistory'
import Story from '@/components/Story'
import Poem from '@/components/Poem'
import ArticleList from '@/components/ArticleList'
import Article from '@/components/Article'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      meta: {
        title: 'naranzug 首页',
        keepAlive: true,
        showCopyRight: true
      }
    },
    {
      path: '/history',
      name: 'MongolHistory',
      component: MongolHistory,
      meta: {
        keepAlive: true,
        title: 'naranzug 蒙古秘史'
      }
    },
    {
      path: '/story',
      name: 'Story',
      component: Story,
      meta: {
        keepAlive: true,
        title: 'naranzug 故事电影'
      }
    },
    {
      path: '/poem',
      name: 'Poem',
      component: Poem,
      meta: {
        keepAlive: true,
        title: 'naranzug 诗歌谚语'
      }
    },
    {
      path: '/story/:cateid',
      name: 'Story_list',
      component: ArticleList,
      meta: {
        activeIndex: '2',
        title: 'naranzug 故事电影'
      }
    },
    {
      path: '/poem/:cateid',
      name: 'Poem_list',
      component: ArticleList,
      meta: {
        activeIndex: '3',
        title: 'naranzug 诗歌谚语'
      }
    },
    {
      path: '/p/:id',
      name: 'Article',
      component: Article
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js